<template>
  <v-container fill-height fluid>
    <v-layout justify-center align-center>
      <v-flex column lg8 align-self-center>
        <material-card
          icon="mdi-electricity-bill"
          color="indigo"
          :title="$t('Pages.ElectricityBills.add_new')"
          :text="$t('Common.enter_details')">
          <v-card-text>
            <electricity-bill-form @save="add" :electricityBill="electricityBill"></electricity-bill-form>
          </v-card-text>
        </material-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
    import ElectricityBillForm from './Form'
    import moment from 'moment'
export default {
  components: {ElectricityBillForm},
  data: () => ({
    electricityBill: {},
  }),
  computed: {
  },
  created() {
    this.electricityBill.date = moment().format('YYYY-MM-DD');
    this.setFetching(true);
    this.repositories.electricityConstant.all().then(response => {
      for (let i = 0; i < response.data.data.length; i++) {
        let constant = response.data.data[i];
        this.electricityBill[constant.key] = constant.value;
      }
      this.electricityBill = {...this.electricityBill};
    }).finally(() => {
      this.setFetching(false);
    });
    this.repositories.electricitySupplier.all().then(response => {
      let supplier = null;
      let year = moment().year();
      for (let i = 0; i < response.data.data.length; i++) {
        supplier = response.data.data[i];
        if (supplier.year == year) {
          break;
        }
      }
      if (supplier) {
        this.electricityBill.aevt_price = supplier.aevt_price;
        this.electricityBill.aent_price = supplier.aent_price;
        this.electricityBill = {...this.electricityBill};
      }
    }).finally(() => {
      this.setFetching(false);
    });
    this.getLastBill();
  },
  methods: {
      add(data){
          this.repositories.electricityBill.store(data).then((response) => {
              this.$toast.success(response.data.message);
              this.electricityBill = {};
          });
      },
      getLastBill() {
        this.loading = true;
        this.repositories.electricityBill.search({end: this.electricityBill.date, orderBy:'date,desc', pagination: 1}).then(response => {
          this.electricityBill.aevt_old = null;
          this.electricityBill.aent_old = null;
          this.electricityBill.revt_old = null;
          this.electricityBill.rent_old = null;
          let data = response.data.data;
          if (!data || data.length == 0) {
            return;
          }
          let lastBill = data[0];
          this.electricityBill.aevt_old = lastBill.aevt;
          this.electricityBill.aent_old = lastBill.aent;
          this.electricityBill.revt_old = lastBill.revt;
          this.electricityBill.rent_old = lastBill.rent;
          this.electricityBill = {...this.electricityBill};
        }).finally(() => {
          this.loading = false;
        });
      }
  },
  watch: {
    'electricityBill.date': function (){
      this.getLastBill();
    }
  }
}
</script>

<style lang="scss">

</style>
